import React, { useEffect, useState } from "react";
import axios from "../axiosInstance";
import { Sidebar } from "../components/Sidebar";
import { Header } from "../components/Header";
import { Footer } from "../components/ Footer";
import HighPerformanceAd from "../components/HighPerformanceAd";

export default function ReferralPage({ onLogout }) {
  const [coinz, setCoinz] = useState(0);
  const [options, setOptions] = useState(0);
  const [weeklyProfit, setWeeklyProfit] = useState(0);
  const [selfWeeklyProfit, setSelfWeeklyProfit] = useState(0); // Your own earnings
  const [refCode, setRefCode] = useState("");
  const [visitStats, setVisitStats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [username, setUsername] = useState("");

  // 📡 USER DATA FETCHING via API
  const getUserData = () => {
    axios
      .get(`/api/user/me`, { withCredentials: true })
      .then((response) => {
        const {
          coinz,
          options,
          systemCoinz,
          weeklyProfit,
          lastclaim,
          ref_code,
          userLevel,
          user_Xp,
          xpForNextLevel,
        } = response.data;

        const calculatedValue =
          options > 0 ? (systemCoinz / weeklyProfit) * options : 0;

        setSelfWeeklyProfit(calculatedValue);
        setCoinz(coinz);
        setOptions(options);
        setWeeklyProfit(weeklyProfit);
        setRefCode(ref_code);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    document.title = "PTP | CoinzUp";

    getUserData();

    // Fetch PTP visit statistics
    axios
      .get("/api/ptp/stats")
      .then((res) => {
        setVisitStats(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching PTP stats:", err);
        setLoading(false);
      });
  }, []);

  if (loading) return <div className="text-white p-8">Loading...</div>;

  const referralLink = `${window.location.origin}/ptp?ptp_code=${refCode}`;

  return (
    <div className="min-h-screen flex flex-col bg-gray-900 text-gray-100 font-sans">
      <div className="flex flex-1 min-h-[calc(100vh-64px)]">
        <Sidebar onLogout={onLogout} />

        <main className="flex-1 px-8 py-10 space-y-10 overflow-auto bg-gray-900">
          <Header
            title="Pay To Promote"
            balance={coinz}
            optionsOwned={options}
            estimatedWeeklyGain={selfWeeklyProfit}
          />

          <HighPerformanceAd
            keyId="fd5da3543c594f07b73630f461f10613"
            width={728}
            height={90}
          />

        <div className="bg-gray-800 p-6 rounded-2xl shadow-lg">
          <h2 className="text-xl font-bold text-yellow-400 mb-4">
             Boost Your Earnings with PTP!
          </h2>
          <p className="text-gray-300 text-sm mb-4">
            Share your personalized Pay To Promote (PTP) link everywhere — on social media, forums, chats, or blogs — and start earning rewards instantly. The more people visit, the more Coinz you collect. It's simple, powerful, and the perfect way to grow your balance passively.
          </p>

          <ul className="list-disc list-inside space-y-2 text-sm text-gray-300">
            <li> You earn <b>100 Coinz</b> for every first-time visit from a unique IP.</li>
            <li> Repeat visits from the same IP still earn you <b>1 Coinz</b> (up to 10 per IP per day).</li>
            <li> <b>Autosurfing, bots, and cheating are strictly forbidden</b> and may lead to a ban.</li>
            <li> The more places you share your link, the more chances you have to earn daily.</li>
            <li> If someone signs up with your referral code, you get <b>50% of their PTP earnings</b> automatically — for life!</li>
            <li> <b>⚠️ A reward is only given if the visitor stays at least 15 seconds on the promoted page.</b></li>
          </ul>

          <p className="text-green-400 text-sm mt-4">
            💡 Tip: Post your link on niche communities or active Discord servers for the best results!
          </p>
        </div>



          <div className="bg-gray-800 p-6 rounded-2xl shadow-lg">
            <h2 className="text-lg font-semibold mb-3 text-blue-400">
               Your PTP link
            </h2>
            <div className="flex items-center justify-between bg-gray-700 p-3 rounded-lg">
              <code className="truncate">{referralLink}</code>
              <button
                onClick={() => {
                  navigator.clipboard.writeText(referralLink);
                  alert("Link copied!");
                }}
                className="bg-yellow-500 text-black px-3 py-1 rounded hover:bg-yellow-600"
              >
                Copy
              </button>
            </div>
          </div>

          <div className="bg-gray-800 p-6 rounded-2xl shadow-lg">
            <h2 className="text-lg font-semibold mb-3 text-green-400">
               Visits per day
            </h2>
            <div className="overflow-auto">
              <table className="min-w-full text-sm text-left text-gray-300">
                <thead className="text-xs uppercase bg-gray-700 text-gray-200">
                  <tr>
                    <th className="px-4 py-2">Date</th>
                    <th className="px-4 py-2">Visit count</th>
                  </tr>
                </thead>
                <tbody> 
                  {visitStats.map((row) => (
                    <tr key={row.date} className="border-t border-gray-700">
                      <td className="px-4 py-2">
                        {new Date(row.date).toISOString().slice(0, 10)}
                      </td>
                      <td className="px-4 py-2">{row.visits}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {visitStats.length === 0 && (
                <p className="text-gray-400 mt-4">
                  No visits recorded yet.
                </p>
              )}
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
}
